"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var unique = function unique(value, index, self) {
  return self.indexOf(value) === index;
};

var _default = function _default(list) {
  var distinctor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (item) {
    return item;
  };
  var items = list.map(func).filter(unique);

  if (!distinctor) {
    return items;
  }

  var dict = items.reduce(function (accumulator, item) {
    if (!accumulator[item[distinctor]]) {
      accumulator[item[distinctor]] = item;
    }

    return accumulator;
  }, {});
  return Object.keys(dict).map(function (key) {
    return dict[key];
  });
};

exports["default"] = _default;